module.exports = __webpack_public_path__ + "assets/img/1.e4747eaa.svg";